// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"64":"editEvent","594":"inspiration"}[chunkId] + "." + {"64":"011fe7622b109ee8400b","594":"a3cfbace0d5920454af1"}[chunkId] + ".bundle.js";
};